import React from "react";
import { Navigate } from "react-router-dom";
import useAuthListener from "../hooks/useAuthListener";

export default function PrivateRoute({ children }) {
  const { user, loading } = useAuthListener();

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "2rem" }}>Loading…</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
}
